<template>
  <div class="add-developer-menu row">
    <div class="col">
      <div class="add-developer-menu__button">
        <img
          class="add-developer-menu__button-icon"
          src="@/assets/img/add-new-import.svg"
          alt="icon" />
        <img
          class="add-developer-menu__button-icon--light"
          src="@/assets/img/add-new-import-light.svg"
          alt="icon" />
        <p class="add-developer-menu__button-text">Import from .CSV</p>
      </div>
    </div>
    <div class="col">
      <div class="add-developer-menu__button" @click="selectFormType('InviteForm')">
        <img
          class="add-developer-menu__button-icon"
          src="@/assets/img/add-new-send.svg"
          alt="icon" />
        <img
          class="add-developer-menu__button-icon--light"
          src="@/assets/img/add-new-send-light.svg"
          alt="icon" />
        <p class="add-developer-menu__button-text">Send an invitation</p>
      </div>
    </div>
    <div class="col">
      <div class="add-developer-menu__button" @click="selectFormType('JoinForm')">
        <img
          class="add-developer-menu__button-icon"
          src="@/assets/img/add-new-form.svg"
          alt="icon" />
        <img
          class="add-developer-menu__button-icon--light"
          src="@/assets/img/add-new-form-light.svg"
          alt="icon" />
        <p class="add-developer-menu__button-text">Add manually</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    selectFormType(type) {
      this.$emit('select', type);
    },
  },
};
</script>

<style lang="scss" scoped>
.add-developer-menu {
  &__button {
    border: 1px solid #E2E6EA;
    border-radius: 4px;
    padding: 60px 0;
    text-align: center;
    cursor: pointer;
    min-height: 212px;

    &:hover {
      background: $color--blue;
      border-color: $color--blue;

      .add-developer-menu__button-text {
        color: white;
      }
      .add-developer-menu__button-icon {
        display: none;
      }
      .add-developer-menu__button-icon--light {
        display: inline-block;
      }
    }
  }

  &__button-icon {
    display: inline-block;
  }

  &__button-icon--light {
    display: none;
  }

  &__button-text {
    margin-bottom: 0px;
    color: $color--primary;
    margin-top: 16px;
  }
}
</style>
